import React, { useEffect, useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import api from "../lib/api";

export function SupplierSelect({ value, onChange, placeholder = "Select supplier...", testId = "supplier-select" }) {
  const [open, setOpen] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [query, setQuery] = useState("");

  useEffect(() => {
    api.get("/suppliers?active=true").then(({ data }) => setSuppliers(data)).catch(() => {});
  }, []);

  const selected = suppliers.find((s) => s.id === value);
  const filtered = query
    ? suppliers.filter((s) => s.name.toLowerCase().includes(query.toLowerCase()) || (s.code || "").toLowerCase().includes(query.toLowerCase()))
    : suppliers;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          data-testid={testId}
          className="w-full justify-between font-normal"
        >
          <span className={selected ? "" : "text-muted-foreground"}>
            {selected ? selected.name : placeholder}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <div className="flex items-center border-b px-3">
          <Search className="h-4 w-4 text-muted-foreground" />
          <input
            autoFocus
            data-testid={`${testId}-search`}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Type to search suppliers..."
            className="flex h-10 w-full bg-transparent px-2 text-sm outline-none placeholder:text-muted-foreground"
          />
        </div>
        <div className="max-h-64 overflow-y-auto p-1">
          {filtered.length === 0 && (
            <div className="px-3 py-6 text-center text-sm text-muted-foreground">No suppliers found</div>
          )}
          {filtered.map((s) => (
            <button
              key={s.id}
              type="button"
              data-testid={`${testId}-option-${s.id}`}
              onClick={() => { onChange(s.id, s); setOpen(false); setQuery(""); }}
              className="flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm hover:bg-accent hover:text-accent-foreground"
            >
              <span className="truncate">{s.name}</span>
              {value === s.id && <Check className="h-4 w-4 text-blue-600" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
